import { useContext } from "react";
import { MainContext } from "../App";
import CloseIcon from "../icons/CloseIcon";

function Settings() {
	const { setPopupVisible, thermalPrinters, waiterSettings, setWaiterSettings } =
		useContext(MainContext);

	return (
		<div className="popup settings-popup">
			<div className="container settings-popup-container">
				<header>
					<div>Impostazioni</div>
					<button
						className="btn btn-tertiary btn-square"
						onClick={() => setPopupVisible(false)}
					>
						<CloseIcon />
					</button>
				</header>
				<div className="content">
					<div className="settings-field">
						<div className="settings-field-label">Stampante preconto</div>
						<div className="settings-field-help">
							Seleziona la stampante su cui stampare il preconto da lasciare al cliente
						</div>
						<select
							value={waiterSettings.thermal_printer_id || ""}
							onChange={(e) =>
								setWaiterSettings({
									...waiterSettings,
									thermal_printer_id: e.target.value || null,
								})
							}
						>
							<option value="">Nessuna</option>
							{thermalPrinters.map((printer) => (
								<option key={printer.id} value={printer.id}>
									{printer.name}
								</option>
							))}
						</select>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Settings;
